
interface KeyHelperProps {
  children: string | JSX.Element;
}

const KeyHelper = ({ children }: KeyHelperProps) => {
  return (
    <div className="bg-white-800 text-gray-600 text-sm rounded-md p-1">
      {children}
    </div>
  );
};

export default KeyHelper;
